export const HEADER_CREATE_BUTTON = "Create Business Profile";
export const HEADER_LOGIN_BUTTON = "Log in";
export const QUICK = "Solutions";
export const COMPANY = "Business";
export const TRADE = "Trade Information";
export const TRADE_FINANCE = "Trade Finance";
export const TRADE_RISK = "Trade Risk";
export const QUICK_LINKS = [
  { url: "/financial-institutions", url2: "/financial-institutions", text: "Financial Institutions" },
  { url: "/credit-insurers", url2: "/credit-insurers", text: "Credit Insurers" },
  { url: "/sellers", url2: "/sellers", text: "Sellers" },
  { url: "/buyers", url2: "/buyers", text: "Buyers" },
];

export const TRADE_LINKS = [
  { url: "/information-as-a-service", url2: "/information-as-a-service", text: "Information-as-a-Service" },
  { url: "/credit-assessment-reports", url2: "/credit-assessment-reports", text: "Credit Assessment Reports" },
  { url: "/self-assessment-report", url2: "/self-assessment-report", text: "Self Assessment Reports" },
  { url: "/plans", url2: "/plans", text: "Plans" },
];

export const TRADE_FINANCE_LINKS = [
  { url: "/buy-now-pay-later", url2: "/buy-now-pay-later", text: "Buy Now Pay Later" },
  { url: "/supply-chain-finance", url2: "/supply-chain-finance", text: "Supply Chain Finance" },
];

export const TRADE_RISK_LINKS = [
  { url: "/debt-mediation-collection", url2: "/debt-mediation-collection", text: "Debt Mediation & Collection" },
  { url: "/credit-policy-development-risk-assessment", url2: "/credit-policy-development-risk-assessment", text: "Credit Policy Development" },
  { url: "/ai-powered-collection-prompts", url2: "/ai-powered-collection-prompts", text: "AI-Powered Collection Prompts" },
];

export const COMPANY_LINKS = [
  { url: "/", url2: "/", text: "Home" },
  { url: "/sign-up", url2: "/sign-up", text: "Sign Up" },
];

export const COMPANY_LINKS_2 = [
  { url: "/plans", url2: "/plans", text: "Pricing" },
  { url: "/dashboard", url2: "/dashboard", text: "Dashboard" },
];

export const FOOTER_LINK_BOTTOM = [
  {
    url: "/terms-and-condition",
    url2: "/terms-and-condition",
    text: "Terms & Conditions",
  },
  { url: "/privacy-policy", url2: "/", text: "Privacy Policy" },
];

export const HOME_BANNER_TEXT = "Explore. <span>Engage.</span> Expand.";
export const HOME_BANNER_TEXT_2 =
  "Partner with confidence and realise the true potential of your business";

export const CREATE_PROFILE_TITLE = "Create Your Profile";
export const CREATE_PROFILE_BUTTON = "Create Profile";
export const CREATE_PROFILE = [
  "Get reports that are regularly updated",
  "Get your business verified and claim all the features of TREVEX",
  "Follow business profile and stay updated about any changes made",
];

export const CREATE_PROFILE_VERTICAL_TITLE = "Can't Find Your Business?";
export const CREATE_PROFILE_VERTICAL_BUTTON = "Get Started";
export const CREATE_VERTICAL_PROFILE = [
  "Present your business",
  "Get Verified",
  "Increase visibility",
];

export const NOT_FOUND_TITLE = "Business not found?";
export const NOT_FOUND_SUBTITLE = "Order a fresh report on a business now.";

export const SEARCH_BUTTON_TITLE = "Find Business";
export const SEARCH_LENGTH_ERROR =
  " Business name should have a minimum length of three characters.";
export const SEARCH_COMPANY_NOT_FOUND =
  "We couldn't find any results for your business name. Please try refining your search terms.";
export const pgColors = ["#FFB894", "#FF8864", "#FE6B47", "#FB512D"];
export const plansInformation = [
  {
    title: "Pay-as-you-go",
    mode: "one-time",
    slug: "pay-as-you-go",
    subsCharge: 79,
    talkToSales: true,
    Features: [
      "1 profile views for 1 month",
      "full profile claim for 1 month.",
    ],
  },
  {
    title: "Basic",
    mode: "subscription",
    slug: "basic",
    subsCharge: 195,
    talkToSales: true,
    Features: [
      "3 profile views for 1 month",
      "full profile claim for 1 month",
    ],
  },
  {
    subsType: "Recommended",
    title: "Pro",
    slug: "pro",
    mode: "subscription",
    subsCharge: 275,
    talkToSales: true,
    Features: [
      "5 profile views per month",
      "full profile claim for 1 month",
    ],
  },
  {
    title: "Premium",
    mode: "subscription",
    slug: "premium",
    subsCharge: 500,
    talkToSales: true,
    Features: [
      "10 profile views per month",
      "full profile claim for 1 month",
    ],
  },
];

